import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Services } from './components/Services';
import { Results } from './components/Results';
import { Testimonials } from './components/Testimonials';
import { CtaBanner } from './components/CtaBanner';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-nude selection:bg-rosegold selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainPoints data-id="element-4" />
        <Services data-id="element-5" />
        <Results data-id="element-6" />
        <Testimonials data-id="element-7" />
        <CtaBanner data-id="element-8" />
        <Contact data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}